import { Component } from '@angular/core';
import { NavController, App } from 'ionic-angular';
import { RegisterPage } from "../register/register";
import { AgencyMemberSearchPage } from "../agencyMemberSearch/agencyMemberSearch";
import { AgentAutoRegPage } from "../agentAutoReg/agentAutoReg";
import { AgencyUserTBalancePage } from "../agencyUserTBalance/agencyUserTBalance";
import { ReportWinLossSearchPage } from "../reportWinLossSearch/reportWinLossSearch";
import { ReportDTSearchPage } from "../reportDTSearch/reportDTSearch";
import { AgentPEPage } from "../agentPE/agentPE";
import { ReportWinLoss2SearchPage } from "../reportWinLoss2Search/reportWinLoss2Search";
import { PersonMsgPage } from '../personMsg/personMsg';
import { SysMsgListPage } from '../sysMsgList/sysMsgList';
import { GameRecordSearchPage } from '../gameRecordSearch/gameRecordSearch';
import { BalanceChangeSearchPage } from '../balanceChangeSearch/balanceChangeSearch';
import { TranslateService } from 'ng2-translate';


@Component({
    templateUrl: 'agencyManage.html',
    selector: 'agency-manage-page'
})
export class AgencyManagePage {
    listAgency: any[];

    constructor(
        private app: App, 
        private translate: TranslateService,
        private navController: NavController
    ) {
        this.initializeListAgency();
    }

    private initializeListAgency() {
        this.listAgency = [
            {
                label: 'AGENCY_MEMBER',
                children: [
                    {
                        icon: 'zhuce',
                        title: 'MESSAGE',
                        des: 'SYSTEM_MESSAGES',
                        page: PersonMsgPage,
                        src: 'profile',
                    },
                    {
                        icon: 'huiyuan',
                        title: 'NOTIFICATIONS',
                        des: 'SYSTEM_NOTIFICATIONS',
                        page: SysMsgListPage,
                        src: 'member',
                    }
                ],
            },
            {
                label: 'AGENCY_REPORT',
                children: [
                    {
                        icon: 'tuandui',
                        title: 'REPORT_TOTAL',
                        des: 'TOTAL_PROFIT',
                        page: ReportDTSearchPage,
                        src: 'group',
                    },
                    {
                        icon: 'baobiao',
                        title: 'BET_HISTORY',
                        des: 'BET_HISTORY_DESC',
                        page: GameRecordSearchPage,
                        src: 'statitic',
                    },
                    {
                        icon: 'baobiao2',
                        title: 'BALANCE_CHANGE',
                        des: 'BALANCE_CHANGE_DESC',
                        page: BalanceChangeSearchPage,
                        src: 'calendar',
                    }
                ],
            },
        ];
    }

    goPage(page: any) {
        this.app.getRootNav().push(page);
    }
}



// WEBPACK FOOTER //
// ./src/pages/agencyManage/agencyManage.ts